



































import { defineComponent, computed, ref } from '@vue/composition-api'

export default defineComponent({
  props: {
    visitorId: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const copySnackbar = ref(false)

    const shareUrl = computed(
      () => `${location.origin}/tournament/${props.visitorId}`,
    )

    function clipboardSuccessHandler() {
      copySnackbar.value = true
    }

    function close() {
      copySnackbar.value = false
      emit('close')
    }

    return {
      close,
      shareUrl,
      clipboardSuccessHandler,
      copySnackbar,
    }
  },
})
